import React, { useEffect } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useLocalStorage from 'react-localstorage-hook';

export const OrdersClosedTab = () => {
  const [, setShouldPublish] = useLocalStorage('shouldPublishOrdersClosed', false);

  useEffect(() => {
    setShouldPublish(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePublish = () => setShouldPublish(true);

  return (
    <Accordion id="ordersClosedTab">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>ordersClosed</Typography>
        <Button
          id="publish-orders-closed"
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handlePublish();
          }}
          variant="contained"
        >
          Publish
        </Button>
      </AccordionSummary>
      <AccordionDetails />
    </Accordion>
  );
};
